<section class="flex h-full w-full min-h-0 flex-col bg-shui-base-3 rounded-md overflow-auto">
    <div class="p-4 text-shui-text-strong flex-1 min-h-0">
        <div class="grid grid-cols-5">
            @for (weekday of weekdays(); track $index) {
                <div class="p-2 text-center">
                    <span class="text-lg font-sh-bree-headline text-shui-text-moderate">
                        {{ 'common.calendar.weekdays.' + weekday | translate }}
                    </span>
                </div>
            }

            @for (week of weeks(); track $index) {
                @for (calendarDay of week; track $index) {
                    @if (calendarDay) {
                        <div
                            class="grid auto-rows-fr text-shui-text-strong"
                            [class.bg-shui-base-1]="
                                calendarDay.day.getMonth() !== date().getMonth() && calendarView() === 'month'
                            "
                            [class.text-shui-text-subtle]="
                                calendarDay.day.getMonth() !== date().getMonth() && calendarView() === 'month'
                            "
                        >
                            <div
                                class="border-0 border-b border-solid border-shui-base-4 bg-shui-base-2 px-2"
                                [class.text-shui-text-subtle]="
                                    calendarDay.day.getMonth() !== date().getMonth() && calendarView() === 'month'
                                "
                            >
                                <span
                                    class="flex h-[25px] w-[25px] items-center justify-center text-lg font-black p-1 my-1"
                                    [class.bg-shs-orange]="isToday(calendarDay.day)"
                                    [class.text-white]="isToday(calendarDay.day)"
                                    [class.rounded-full]="isToday(calendarDay.day)"
                                >
                                    {{ calendarDay.day.getDate() }}
                                </span>
                            </div>

                            @for (
                                row of Array.from({ length: getMinimumRowCount(week) });
                                track $index;
                                let userIndex = $index
                            ) {
                                @if (calendarDay.users[userIndex]; as userEvent) {
                                    <div
                                        class="px-2 text-center flex items-center text-sm font-bold text-shui-text-strong"
                                        [class.bg-shui-tint-active-150]="
                                            !isEventSelected(userEvent, selectedUserEvent())
                                        "
                                        [class.bg-shui-tint-active-250]="
                                            isEventSelected(userEvent, selectedUserEvent())
                                        "
                                        [class.border-l-2]="isSameDay(calendarDay.day, userEvent.startDate)"
                                        [class.border-l-shui-tint-active-250]="
                                            isSameDay(calendarDay.day, userEvent.startDate)
                                        "
                                        [class.border-r-2]="isSameDay(calendarDay.day, userEvent.endDate)"
                                        [class.border-r-shui-tint-active-250]="
                                            isSameDay(calendarDay.day, userEvent.endDate)
                                        "
                                    >
                                        @if (isShowOnDate(userEvent, calendarDay.day)) {
                                            {{ userEvent.userName }}
                                        }
                                    </div>
                                } @else {
                                    <div
                                        class="bg-shui-base-2 px-2 border-solid border-b border-l-0 border-t-0 border-shui-base-3 text-center text-sm font-bold"
                                    ></div>
                                }
                            }
                        </div>
                    }
                }
            }
        </div>
    </div>
</section>
